import { FC } from 'react'
import minus from '../../assets/minus.svg'
import Plus from '../../Icon/Plus'

type ChangeCountProps = {
  count: number
  onDecrement: () => void
  onIncrement: () => void
  id: string
}

const ChangeCount: FC<ChangeCountProps> = ({
  count,
  onIncrement,
  onDecrement,
  id,
}) => {
  return (
    <div className="inline-flex rounded-lg bg-white shadow-tooltip border-borderGrey border-[0.5px] px-4 py-2 w-[110px]">
      <button className="mr-4" onClick={onDecrement}>
        <img alt="decrement" src={minus} />
      </button>
      <div className="mr-4">{count}</div>
      <button className="text-green" onClick={onIncrement}>
        <Plus id={id} size="16" box="16" />
      </button>
    </div>
  )
}

export default ChangeCount
